import { http } from '../../core/services/http';
import transformLoadPickupFrequencyTypes from './transformLoadPickupFrequencyTypes';

export const doLoadpickupFrequencyTypes = () =>
  http.get('services/pickupFrequencyTypes').then(response => transformLoadPickupFrequencyTypes(response.data));
